import { MetadataState } from "./types";

export function getDefaultState(): MetadataState {
	return {
		metadata: {},
		metadataTypes: [],
		metadataObjectTypes: []
	};
}
